import { C8AttributeId, C8NodeType } from "csi/typings";
import { pathCreate } from "csi/utility/pathUtility";
import xml from "csi/xml";

const { ATTR_PARENT } = xml;

export const TYPE_PRODUCT_SOURCE: C8NodeType = "ProductSource";

export const ATTR_SOURCE_SAMPLES: C8AttributeId = "Samples";
export const ATTR_SOURCE_SUPPLIER_ITEMS: C8AttributeId = "SupplierItems";

export const ATTR_SOURCING_SOURCES: C8AttributeId = "ProductSources";

export const SAMPLE_TO_PRODUCT_PATH = pathCreate(ATTR_PARENT, ATTR_PARENT, ATTR_PARENT);
export const SAMPLE_TO_COLLECTION_PATH = pathCreate(SAMPLE_TO_PRODUCT_PATH, "Collection");
